import { combineLatest } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ScullyRoute, ScullyRoutesService } from '@scullyio/ng-lib';
import {
    Component,
    ElementRef,
    HostListener,
    Inject,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { GaService } from 'app/shared/services';
import { Meta } from '@angular/platform-browser';
import ClearcalsIcons from 'app/icons/icons.data';

@Component({
    selector: 'clearcals-blog-detail',
    templateUrl: './blog-detail.component.html',
    styleUrls: ['./blog-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class BlogDetailComponent implements OnInit {
    blogs$: any;
    nextBlog: any;
    hostName: string;
    previousBlog: any;
    currentBlogId: number;
    isSmall: boolean;

    // icon
    facebookIcon = ClearcalsIcons.getIcon('facebook');
    twitterIcon = ClearcalsIcons.getIcon('twitter');
    linkedinIcon = ClearcalsIcons.getIcon('linkedin');
    calenderIcon = ClearcalsIcons.getIcon('calender');
    timeIcon = ClearcalsIcons.getIcon('time');
    arrowRightIcon = ClearcalsIcons.getIcon('arrowRight');
    arrowLeftIcon = ClearcalsIcons.getIcon('arrowLeft');

    constructor(
        @Inject('Window') private window: Window,
        private activatedRoute: ActivatedRoute,
        private scully: ScullyRoutesService,
        private breakpoint$: BreakpointObserver,
        private gaService: GaService,
        private router: Router,
        private meta: Meta
    ) {
        this.isSmall = this.breakpoint$.isMatched('(max-width: 960px)');
        this.meta.addTag({
            rel: 'preload',
            href: './blog-detail.component.scss',
            as: 'style',
        });
    }

    $blogPostMetadata = combineLatest([
        this.activatedRoute.params.pipe(pluck('postId')),
        this.scully.available$,
    ]).pipe(
        map(([postId, routes]) =>
            routes.find((route) => route.route === `/blogs/${postId}`)
        )
    );

    ngOnInit(): void {
        this.hostName = `https://${this.window.location.hostname}`;
        this.$blogPostMetadata.subscribe((blog) => {
            this.currentBlogId = blog.id;
            this.scully.available$
                .pipe(
                    map((routeList) =>
                        routeList.filter(
                            (route: ScullyRoute) =>
                                route.route.startsWith(`/blogs/`) &&
                                route.sourceFile.endsWith('.md')
                        )
                    )
                )
                .subscribe((blogs) => {
                    const blogId = blogs
                        .sort((x, y) => x.id - y.id)
                        .findIndex((x) => x.id === this.currentBlogId);

                    this.previousBlog =
                        blogs[(blogId + blogs.length - 1) % blogs.length];
                    this.nextBlog =
                        blogs[(blogId + blogs.length + 1) % blogs.length];
                });
        });
    }

    // GA click event
    clickShopNow() {
        this.gaService.gaEventFun({
            action: 'shop_now_click',
            label: this.router.url,
        });
    }

    // GA view event
    @ViewChild('socialMediaBanner', { static: false })
    private socialMediaBanner: ElementRef<HTMLDivElement>;
    isSocialMediaBannerScrolledIntoView: boolean = false;

    @HostListener('window:scroll', ['$event'])
    isScrolledIntoView() {
        if (
            this.socialMediaBanner &&
            !this.isSocialMediaBannerScrolledIntoView
        ) {
            const rect =
                this.socialMediaBanner.nativeElement.getBoundingClientRect();
            const bottomShown = rect.bottom <= window.innerHeight;
            this.isSocialMediaBannerScrolledIntoView = bottomShown;
            if (this.isSocialMediaBannerScrolledIntoView) {
                this.gaService.gaEventFun({
                    action: 'social_media_banner_view',
                    label: this.router.url,
                });
            }
        }
    }
}
